import Container from '@ui/container/container';
import { defaultWatermark } from './watermark.constants';
import WatermarkCss from './watermark-edit';
import { Navigate } from 'react-router-dom';

export default function DebugWatermarkCanvas() {
  if (import.meta.env.VITE_STAGE_LOCAL !== 'local') {
    return <Navigate to="/" />;
  }

  return (
    <Container height="100svh" width="100svw" background={'gray'} className="overflow-hidden">
      <WatermarkCss watermark={defaultWatermark} />
    </Container>
  );
}
